export const usePreview = () => {
  let previewToken = '';
  if (import.meta.server) {
    previewToken = useRequestURL().searchParams.get('__preview') ?? '';
  } else if (typeof window !== 'undefined') {
    previewToken = new URLSearchParams(window.location.search).get('__preview') ?? '';
  }
  const previewCookie = useCookie('__preview').value === '1';
  const isPreview = Boolean(previewToken) || previewCookie;

  return {
    isPreview,
    previewToken,
    previewQuery: previewToken ? { __preview: previewToken } : {},
    previewKeyPart: isPreview ? 'preview-' : '',
  };
};
